import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDayLightClouds: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M35.2072 53.2508C27.2114 54.4431 20.9924 60.9816 20.6261 68.9775C16.558 62.0259 14.9604 53.5703 16.6905 45.0679C20.213 27.9773 36.0723 16.5446 53.0771 18.15C54.3162 18.2435 55.5476 18.4228 56.8257 18.6956C58.1505 18.9683 59.4754 19.3346 60.7534 19.7476C58.5168 20.7997 56.3658 22.0311 54.4877 23.5897C49.4688 27.611 45.8138 33.3702 44.3954 40.1347C44.1227 41.3661 43.9824 42.5584 43.8967 43.743C40.0936 45.9407 37.0386 49.2295 35.2072 53.2508Z"
        fill="#D2D4DA"
      />
      <path
        d="M76.2078 65.7744L71.8669 65.6341L71.7734 61.2933C71.5474 52.5649 63.9568 45.4341 54.8153 45.4341C50.7473 45.4341 46.952 46.8525 43.9827 49.2761C42.0188 50.827 40.4212 52.8377 39.3613 55.1678L38.3171 57.4123L35.8934 57.7786C29.7679 58.6904 25.1465 63.8573 25.1465 69.7957C25.1465 74.0041 27.3909 77.7526 30.7654 79.8958C32.7761 81.2206 35.1998 81.9999 37.8495 81.9999H65.5934H75.9662C80.6733 81.9999 84.4686 78.3449 84.4686 73.8638C84.4842 69.523 80.7824 65.8679 76.2078 65.7744Z"
        fill="#D2E0FF"
      />
    </svg>
  )
}

export default WeatherIconDayLightClouds
